import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const MAILTO = "mailto:info@clevantatechnologies.com?subject=Project%20enquiry%20%E2%80%94%20Clevanta";

const links = [
  ["services", "Services"],
  ["process", "Process"],
  ["cases", "Use cases"],
  ["tech", "Stack"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 px-4 pt-4 sm:px-6"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between rounded-full border border-ink/10 bg-[#FBF9F5]/75 py-2.5 pl-5 pr-2.5 backdrop-blur-xl">
        <Logo testId="nav-logo" />
        <div className="hidden items-center gap-8 lg:flex">
          {links.map(([id, label]) => (
            <Link key={id} to={`/#${id}`} data-testid={`nav-link-${id}`} className="link-underline text-sm font-medium text-ink/80 hover:text-ink">
              {label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Link to="/contact" data-testid="nav-cta-contact" className="group hidden items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-[#FBF9F5] transition-colors hover:bg-violet sm:flex">
            Contact us
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
          <button data-testid="nav-mobile-toggle" aria-label="Menu" onClick={() => setOpen(!open)} className="flex h-11 w-11 items-center justify-center rounded-full bg-ink text-[#FBF9F5] lg:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="mx-auto mt-2 max-w-7xl rounded-3xl border border-ink/10 bg-[#FBF9F5] p-6 lg:hidden"
          >
            {links.map(([id, label]) => (
              <Link key={id} to={`/#${id}`} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${id}`} className="block border-b border-ink/10 py-3 font-display text-3xl text-ink">
                {label}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} data-testid="nav-mobile-cta" className="mt-5 flex items-center justify-center gap-2 rounded-full bg-coral py-3.5 font-semibold text-white">
              Contact us <ArrowUpRight className="h-4 w-4" />
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
